<!-- <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="card">
                                <div class="card-header card-header-icon" data-background-color="rose">
                                    <i class="material-icons">perm_identity</i>
                                </div>
                                <div class="card-content">
                                    <h4 class="card-title">Edit Project Details
                                    </h4>
                                    <form (ngSubmit)="onSubmit(editProjectForm.value); editProjectForm.reset()" #editProjectForm="ngForm">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group label-floating">
                                                    <label class="control-label">Project Name</label>
                                                    <input type="text" class="form-control" name="name" required [(ngModel)]="name">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group label-floating">
                                                    <label class="control-label">Project Details</label>
                                                    <input type="text" class="form-control" name="details" [(ngModel)]="details">
                                                </div>
                                            </div>
                                        </div>
                                        <button type="submit" class="btn btn-rose pull-right" [disabled]="!editProjectForm.valid">Update Project</button>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div> -->
<div class="row title">
  <h3>Dashboard / <span>Edit Project</span></h3>
</div>
<div class="row inputForm bg_dashboard justify-content-center">
  <div class="col-12" *ngIf="erroralert">
  	<div class="alert-box grid-100" *ngIf="errorMessage">
  		<div class="alert alert-danger mt-3 text-center">
  			<a class="close link" data-dismiss="alert" (click)="erroralert=false">×</a>
  			{{errorMessage}}
  		</div>
  	</div>
  </div>
  <div class="col-12" *ngIf="successalert">
  	<div class="alert-box grid-100" *ngIf="successMessage">
  		<div class="alert alert-success mt-3 text-center">
  			<a class="close link" data-dismiss="alert"  (click)="successalert=false">×</a>
  			{{successMessage}}
  		</div>
  	</div>
  </div>
  <div class="col-8">
    <div class="statusBar">
      <div class="progress">
        <div class="progress-bar progressBar" role="progressbar" style="width: 60%" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <p class="preValue ml-2">60%</p>
    </div>
    <form (ngSubmit)="onSubmit(editProjectForm.value); editProjectForm.reset()" #editProjectForm="ngForm" class="mt-3 form-horizontal">
      <div class="inputBox">
        <label class="productLabel">Project Name :</label>
        <input type="text" class="form-control productInput" name="name" required [(ngModel)]="name" placeholder="Project Name*">
        <!--<i class="fa fa-pencil edit float-right fontAwesomeIcon" aria-hidden="true"></i>-->
      </div>
      <div class="inputBox">
        <label class="productLabel">Project Descriptions :</label>
        <input type="text" class="form-control productInput" name="details" [(ngModel)]="details" placeholder="Project Details*">
        <!--<i class="fa fa-pencil edit float-right fontAwesomeIcon" aria-hidden="true"></i>-->
      </div>
      <div class="col-12 p-0">
        <p class="mt-3">Floor Plans</p>
        <div class="box mt-2">
          <div class="row">
            <div class="col-7">
              <label class="inputLabel">Floor Plan Details :</label>
              <input type="text" class="form-control boxInput">
            </div>
            <div class="col-5">
              <p class="fileName">Filename.exe</p>
              <i class="fa fa-times closeButton" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <div class="box mt-2">
          <div class="row">
            <div class="col-7">
              <label class="inputLabel">Floor Plan Details :</label>
              <input type="text" class="form-control boxInput">
            </div>
            <div class="col-5">
              <p class="fileName">Filename.exe</p>
              <i class="fa fa-times closeButton" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <div class="box mt-2">
          <div class="row">
            <div class="col-7">
              <label class="inputLabel">Floor Plan Details :</label>
              <input type="text" class="form-control boxInput">
            </div>
            <div class="col-5">
              <p class="fileName"><i class="fa fa-cloud-upload" aria-hidden="true"></i> Attach or browse</p>
              <i class="fa fa-times closeButton" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>
      <p class="text-right addFloorPlan mt-2">Add Another Floor Plan</p>
      <div class="pull-right mt-5">
        <button class="button" [disabled]="!editProjectForm.valid">Update</button>
        <button class="cancel">Cancel</button>
      </div>
    </form>
  </div>
  <div class="col-3">
    <p class="pull-right">Edit</p>
    <p class="profile">Profile</p>
    <div class="details ml-4">
      <p class="profileInner">Assignee : <span>Ram</span></p>
      <p class="profileInner">Customer : <span>Shyam</span></p>
      <p class="profileInner">Designer : <span><i class="fa fa-user mr-3" aria-hidden="true"></i><i class="fa fa-phone" aria-hidden="true"></i></span></p>
      <p class="profileInner">Project Leader : <span>Kaalia</span></p>
      <p class="profileInner">Team Members : <span>5</span></p>
    </div>
    <p class="mt-3">Date</p>
    <div class="details ml-4">
      <p class="profileInner">Created : <span>02-10-2017</span></p>
      <p class="profileInner">Update : <span>09-11-2017</span></p>
      <p class="profileInner">Project Phase : <span>Unit Testing</span></p>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/platform/project/project/edit/edit.component.html